// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA1z7FEUJXp-Ynk_wgE-FFh2S1qP9S7uec",
  authDomain: "uacart-8e2ee.firebaseapp.com",
  projectId: "uacart-8e2ee",
  storageBucket: "uacart-8e2ee.appspot.com",
  messagingSenderId: "763738226053",
  appId: "1:763738226053:web:3062b9869c8f697ba658ec"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);